<template>
  <div :class="overlayClasses">
    <!-- placement -->
    <div
      v-if="params.data.placements && params.options.placements.visible"
      class="placements"
    >
      <div
        class="placements-list"
        :style="placementsStyles.default"
      >
        <div
          v-for="(place, index) in params.data.placements"
          :key="index"
          class="placements-list__item"
          :style="place == 1 ? placementsStyles.first : placementsStyles.other"
        >
          {{ place }}
        </div>
      </div>
    </div>

    <!-- stats -->
    <div
      v-if="params.options.stats.visible && !hasSession"
      class="statsname-wrapper"
    >
      <div
        class="statsname"
        :style="statsStyles"
      >
        {{params.text}}
      </div>
    </div>

    <!-- username -->
    <div
      v-if="params.data.user.name && params.options.user.visible && showUsername"
      class="username-wrapper"
    >
      <div
        class="username"
        :style="userStyles"
      >
        {{ params.data.user.name }}
      </div>
    </div>

    <!-- session -->
    <div
      v-if="hasSession"
      class="session-wrapper"
    >
      <div
        class="session"
        :style="sessionStyles"
      >
        <span /> CURRENT SESSION:
        {{ timerData.hour }}:{{ timerData.minutes }}:{{ timerData.seconds }}
      </div>
    </div>

    <!-- main -->
    <div
      v-if="params"
      :class="['wz-overlay', {'has-avatar': params.data.user.avatar}]"
      :style="overlayStyles.default"
    >
      <div
        v-if="params.data.user.avatar"
        class="overlay-avatar"
      >
        <img
          :style="{borderRadius: `calc(${params.styles.overlay.borderRadius}px/2)`}"
          :src="params.data.user.avatar"
          alt=""
        >
      </div>
      <div
        v-for="(item, index) in firstData"
        :key="index"
        class="wz-overlay-section"
      >
        <div
          class="wz-overlay-section__value"
          :style="overlayStyles.text"
        >
          {{ item.value }}
        </div>
        <div
          class="wz-overlay-section__label"
          :style="overlayStyles.label"
        >
          {{ item.label }}
        </div>
      </div>
      <div
        class="frame"
        :style="sliderStyles.default"
      >
        <div
          class="frame-slide"
        >
          <!-- main frame slider -->
          <div
            class="slide slide-1"
            :style="sliderStyles.text"
          >
            <div class="logo-text">
              WZHUB.GG
            </div>
          </div>

          <!--  -->
          <div
            v-for="slide in filteredSlides"
            :key="slide.value_key"
            :class="['slide', slide.className]"
            :style="sliderStyles.text"
          >
            <div class="main-text">
              <span>{{ slide.label }}</span>
              <div
                v-if="params.data"
                class="slide-value"
              >
                {{ params.data[slide.value_key] }}
              </div>
              <div v-if="slide.posfix">
                {{ slide.posfix }}
              </div>
            </div>
            <div
              class="bottom-text"
              :style="sliderStyles.label"
            >
              {{
                hasSession
                  ? 'CURRENT SESSION'
                  : getLastGamesString(slide.text, params.data.last_matches)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import overlaySlides from '../utils/overlaySlides';

const animationSettings = {
  opacityIn: [0, 1],
  scaleIn: [0.2, 1],
  scaleOut: 3,
  durationIn: 800,
  durationOut: 600,
  delay: 5000,
};

export default {
  name: 'WZOverlayV2',

  props: {
    params: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      timer: null,
      initInterval: null,
      timerData: {
        seconds: 0,
        minutes: 0,
        hour: 0,
      },
      slides: overlaySlides,
      selects: {
        stats: {
          alltime: {
            key: 'alltime',
            value: 'Alltime',
            slides: ['kpg', 'gulag', 'kd', 'headshot', 'wins'],
          },
          caldera: {
            key: 'caldera',
            value: 'Caldera',
            slides: ['kpg', 'gulag', 'kd', 'headshot', 'wins'],
          },
          rebirth: {
            key: 'rebirth',
            value: 'Rebirth',
            slides: ['kpg', 'kd', 'headshot', 'wins'],
          },
          season3: {
            key: 'season3',
            value: 'Season 3',
            slides: ['kpg', 'gulag', 'kd', 'headshot', 'wins'],
          },
        },
      },
    };
  },

  computed: {
    filteredSlides() {
      if (this.params.options.slides) {
        return this.slides.filter((i) => this.params.options.slides.includes(i.value_key));
      }
      return this.slides;
    },

    overlayStyles() {
      return {
        default: {
          backgroundColor: this.params.styles.overlay.backgroundColor,
          borderColor: this.params.styles.overlay.borderColor,
          borderRadius: `${this.params.styles.overlay.borderRadius}px`,
          borderWidth: `${this.params.styles.overlay.borderWidth}px`,
        },
        text: {
          color: this.params.styles.overlay.textColor,
        },
        label: {
          color: this.params.styles.overlay.labelColor,
        },
      };
    },

    sliderStyles() {
      return {
        text: {
          color: this.params.styles.slider.textColor,
        },
        label: {
          color: this.params.styles.slider.labelColor,
        },
        default: {
          backgroundColor: this.params.styles.slider.backgroundColor,
        },
      };
    },

    userStyles() {
      return {
        color: this.params.styles.user.color,
        backgroundColor: this.params.styles.user.backgroundColor,
        borderRadius: `${this.params.styles.user.borderRadius}px`,
      };
    },

    sessionStyles() {
      return {
        color: this.params.styles.session.color,
        backgroundColor: this.params.styles.session.backgroundColor,
        borderRadius: `${this.params.styles.session.borderRadius}px`,
      };
    },

    statsStyles() {
      return {
        color: this.params.styles.stats.color,
        backgroundColor: this.params.styles.stats.backgroundColor,
        borderRadius: `${this.params.styles.user.borderRadius}px`,
      };
    },

    placementsStyles() {
      return {
        default: {
          backgroundColor: this.params.styles.placements.backgroundColor,
          borderTopLeftRadius: `${this.params.styles.placements.borderRadius}px`,
          borderTopRightRadius: `${this.params.styles.placements.borderRadius}px`,
        },
        first: {
          backgroundColor: this.params.styles.placements.firstColor,
          borderRadius: `${this.params.styles.placements.borderRadius}px`,
        },
        other: {
          backgroundColor: this.params.styles.placements.otherColor,
          borderRadius: `${this.params.styles.placements.borderRadius}px`,
        },
      };
    },

    hasPlacements() {
      return this.params.options.placements.visible;
    },

    hasStats() {
      return this.params.options.stats.visible;
    },

    hasUsername() {
      return this.params.options.user.visible;
    },

    hasSession() {
      return this.params.options.session.visible;
    },

    showUsername() {
      return (this.hasSession && this.params.data.user.avatar) || !this.hasSession;
    },

    overlayClasses() {
      return [
        'wz-overlay-wrapper',
        { 'has-stats': this.hasStats },
        { 'has-placements': this.hasPlacements },
        { 'has-username': this.hasUsername },
        { 'has-session': this.hasSession },
        { 'stats-pos-bc': this.hasStats && this.hasPlacements && !this.hasUsername },
        { 'stats-pos-br': this.hasStats && this.hasPlacements && this.hasUsername },
        { 'stats-pos-tc': this.hasStats && !this.hasPlacements },
        { 'session-pos-bc': this.hasSession && (!this.showUsername || !this.hasUsername) },
      ];
    },

    /**
     * @description данные для первого слайда (который статичен)
     */
    firstData() {
      return [
        {
          label: this.params.options.session.visible ? 'session kd' : 'kd',
          value: this.params.data?.first_kd,
        },
        {
          label: this.params.options.session.visible ? 'session wins' : 'wins',
          value: this.params.data?.first_wins,
        },
        {
          label: this.params.options.session.visible ? 'session kpg' : 'kpg',
          value: this.params.data?.first_kpg,
        },
      ];
    },
  },

  beforeDestroy() {
    clearInterval(this.initInterval);
  },

  mounted() {
    this.createAnimation();
    this.initTimer();

    if (this.params.options.session.visible) {
      this.timer = this.params.options.session.timer;
      this.startSessionTimer();
    }
  },

  methods: {

    /**
     * @description запуск таймера
     */
    startSessionTimer() {
      this.initInterval = setInterval(this.initTimer, 1000);
    },

    /**
     * @description метод запуска таймера
     */
    initTimer() {
      if (this.params.options.session.visible) {
        const seconds = Math.trunc((this.timer) % 60);
        this.timerData.seconds = seconds < 10 ? `${seconds}` : seconds;
        this.timerData.minutes = Math.trunc((this.timer / 60) % 60);
        this.timerData.hour = Math.trunc((this.timer / 60) / 60);

        this.timerData.seconds = this.timerData.seconds < 10 ? `0${this.timerData.seconds}` : this.timerData.seconds;
        this.timerData.minutes = this.timerData.minutes < 10 ? `0${this.timerData.minutes}` : this.timerData.minutes;
        this.timerData.hour = this.timerData.hour < 10 ? `0${this.timerData.hour}` : this.timerData.hour;
        this.timer += 1;
      }
    },

    /**
     * @description обновление таймера
     */
    updateSessionTimer() {
      this.timer = this.params.options.session.timer;
    },

    /**
     * @description метод добавления кадра анимации
     */
    addFrame(animation, i = 0) {
      if (i < this.filteredSlides.length) {
        this.addFrame(
          animation.add({
            targets: this.filteredSlides[i].target,
            opacity: animationSettings.opacityIn,
            scale: animationSettings.scaleIn,
            duration: animationSettings.durationIn,
          }).add({
            targets: this.filteredSlides[i].target,
            opacity: 0,
            scale: animationSettings.scaleOut,
            duration: animationSettings.durationOut,
            easing: 'easeInExpo',
            delay: animationSettings.delay,
          }),
          i + 1,
        );
      }
    },

    /**
     * @description создание анимации стайдов
     */
    createAnimation() {
      const animation = this.$anime.timeline({
        loop: true,
      });
      // add start frame
      animation.add({
        targets: '.frame',
        keyframes: [
          { translateX: -290, duration: 500 },
        ],
        easing: 'easeOutElastic(1, .8)',
        delay: 3000,
      }).add({
        targets: '.frame .slide-1',
        opacity: animationSettings.opacityIn,
        scale: animationSettings.scaleIn,
        duration: animationSettings.durationIn,
      }).add({
        targets: '.frame .slide-1',
        opacity: 0,
        scale: animationSettings.scaleOut,
        duration: animationSettings.durationOut,
        easing: 'easeInExpo',
        delay: animationSettings.delay,
      });

      // add collection frames
      this.addFrame(animation);

      // add end frame
      animation.add({
        targets: '.frame',
        keyframes: [
          { translateX: 300, duration: 500 },
        ],
        easing: 'linear',
      });
    },

    /**
     * @description формирование строки "last n games"
     */
    getLastGamesString(text, count) {
      return text.replace(/n/, count);
    },
  },
};
</script>

<style lang="scss">

.wz-overlay-wrapper {
  position: relative;
  display: inline-flex;

  &.has-placements {
    margin-top: 30px;
    padding-top: 0 !important;
  }

  .statsname-wrapper {
    position: absolute;
    top: -10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    .statsname {
      border-radius: 10px;
      background: #000;
      padding: 5px 15px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
    }
  }

  .session-wrapper {
    position: absolute;
    top: calc(100% - 10px);
    right: 30px;
    left: 0;
    display: flex;
    justify-content: flex-end;

    .session {
      display: flex;
      align-items: center;
      border-radius: 10px;
      background: #000;
      padding: 5px 10px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
      width: 205px;

      span {
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        margin-right: 7px;
        background:red;
      }
    }
  }

  &.stats-pos-bc {
    .statsname-wrapper {
      position: absolute;
      top: calc(100% - 10px);
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
    }
  }

  &.stats-pos-bl {
    .statsname-wrapper {
      position: absolute;
      top: calc(100% - 10px);
      left: 30px;
      display: flex;
      justify-content: flex-start;
    }

    .username-wrapper {
      right: 30px;
      display: flex;
      justify-content: flex-end;
    }
  }

  &.session-pos-bc {
    .session-wrapper {
      justify-content: center;
      right: 0;
      left: 0;
    }
  }

  &.stats-pos-br {
    .statsname-wrapper {
      position: absolute;
      top: calc(100% - 10px);
      right: 30px;
      display: flex;
      justify-content: flex-end;
    }

    .username-wrapper {
      left: 30px;
      display: flex;
      justify-content: flex-start;
    }
  }

  &.has-session {
    .username-wrapper {
      left: 30px;
      display: flex;
      justify-content: flex-start;
    }
  }

  .placements {
    position: absolute;
    top: -28px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    &-list {
      display: grid;
      grid-auto-flow: column;
      align-items: center;
      grid-gap: 3px;
      background: blue;
      padding: 3px;

      border-top-right-radius: 5px;
      border-top-left-radius: 5px;

      &__item {
        width: 22px;
        height: 22px;
        background: #000;
        color: #fff;
        font-size: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px;
        border-radius: 3px;
      }
    }
  }

  .username-wrapper {
    position: absolute;
    bottom: -10px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;

    .username {
      border-radius: 10px;
      background: #000;
      padding: 5px 15px;
      z-index: 4;
      font-size: 11px;
      text-transform: uppercase;
    }
  }
}

.wz-overlay {
  box-sizing: border-box;
  min-width: 350px;
  width: 350px;
  height: 84px;
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  padding: 0 10px;
  background: #1d1d1d;
  border: 0px #fff solid;
  overflow: hidden;

  &.has-avatar {
    min-width: 420px;
    width: 420px;
    grid-template-columns: 70px repeat(3, 1fr);

    .frame {
      width: 60%;
    }
  }

  .overlay-avatar {
    width: 60px;
    height: 60px;
    line-height: 0;

    > img {
      width: 60px;
      height: 60px;
      line-height: 0;
    }
  }

  &-section {
    font-weight: 600;
    font-size: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__label {
      text-transform: uppercase;
      margin-top: 5px;
      font-size: 12px;
    }
  }

  .frame {
    position: absolute;
    height: 100%;
    top: 0;
    right: -330px;
    width: 72%;

    &:before {
      position: absolute;
      content: "";
      width: 71.1%;
      height: 100%;
      transform-origin: 0 100%;
      transform: skew(-15deg);
      background: inherit;
      z-index: -1;
      left: -26px;
    }

    .frame-slide {
      position: absolute;
      top: 0;
      bottom: 0;
      left: -10px;
      right: 35px;
      height: 100%;
      display: flex;
      align-items: center;
      text-transform: uppercase;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;

      .slide {
        position: absolute;
        left: 20px;
        top: 0;
        right: 20px;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 22px;
        font-weight: 600;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .logo-text {
        font-size: 30px;
      }

      .slide-value {
        margin-right: 5px;
        margin-left: 5px;
      }

       .main-text {
        font-size: 18px;
        display: flex;
        align-items: center;

        span {
          font-size: 18px;
          margin-right: 5px;
        }
      }

      .bottom-text {
        font-size: 12px;
        opacity: 0.8;
        margin-top: 5px;
      }
    }
  }

}

.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
